module.exports = __webpack_public_path__ + "static/media/TN-Men-Tshirts.f8647e28.svg";